export const paymentRoutesConfig = {
    PRICING: 'pricing',
    BILLING: 'billing-info',
    INPROGRESS: 'processing/in-progress',
    FAILED: 'processing/failed',
    CONFIRMATION: 'confirmation',
    NETOFF: 'net-off',
} as const;
